import { CalendarDays, Compass, ListVideo, Settings, Sparkles, UsersRound } from "lucide-react";

/**
 * The destinations, as data.
 *
 * Kept out of the component files so the sidebar, the bottom bar and the topbar
 * all render the same list, and so adding a destination is a one-line change
 * rather than an edit in three places.
 */
export const primaryNavigation = [
  { to: "/", label: "navigation.upNext", icon: Sparkles },
  { to: "/calendar", label: "navigation.calendar", icon: CalendarDays },
  { to: "/discover", label: "navigation.discover", icon: Compass },
  { to: "/friends", label: "navigation.friends", icon: UsersRound },
  { to: "/my-lists", label: "navigation.myLists", icon: ListVideo },
] as const;

export const settingsNavigation = {
  to: "/settings",
  label: "navigation.settings",
  icon: Settings,
} as const;

export type NavigationItem = (typeof primaryNavigation)[number] | typeof settingsNavigation;
